import Router from './Route/Router'

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;